import '.hp{box-sizing:border-box;}.ssr-plugin'
import '.h2{border:1px solid var(--gray-200);}.ssr-plugin'
import '.f1{border-radius:1rem;}.ssr-plugin'
import '.hv{padding:1.25rem 1.25rem;}.ssr-plugin'
import '.hw{width:4rem;}.ssr-plugin'
import '.fv{height:4rem;}.ssr-plugin'
import '.ap{flex-shrink:0;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.as{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.fw{gap:2.5rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.d{gap:1rem;}.ssr-plugin'
import '.h{display:grid;}.ssr-plugin'
import '.aa{min-width:0px;}.ssr-plugin'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled, type Style } from 'inlines'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export type CardsSectionItem = {
  title: string
  description: string
  imageSrc?: string
  faIcon?: IconDefinition
}

export type CardsSectionProps = {
  isMobile: boolean
  title: string
  intro: string
  items: ReadonlyArray<CardsSectionItem>
  style?: Style
}

const PainPointCard = ({ item }: { item: CardsSectionItem }) => {
  return (
    <div className="hp h2 f1 hv"
    >
      <Row gap="2rem">
        {item.imageSrc ? (
          <div className="hw fv ap a t as"
          >
            <Image src={item.imageSrc} alt={item.title} />
          </div>
        ) : item.faIcon ? (
          <div className="hw fv ap a t as"
          >
            <FontAwesomeIcon
              icon={item.faIcon}
              style={{
                color: 'var(--palette-blue-800)',
                width: '2.25rem',
                height: '2.25rem',
              }}
            />
          </div>
        ) : null}
        <Column gap="1rem">
          <Title.H4 style={{ marginBottom: 0 }}>{item.title}</Title.H4>
          <Text.Medium
            color="var(--palette-blue-600)"
            style={{ marginBottom: 0 }}
          >
            {item.description}
          </Text.Medium>
        </Column>
      </Row>
    </div>
  )
}

const CardsSection = ({ isMobile, title, intro, items }: CardsSectionProps) => {
  return (
    <div className="a b r fw n"
    >
      <div className="a b d"
        style={{
          maxWidth: isMobile ? '100%' : '33rem',
        }}
      >
        <Title.H2 style={{ marginBottom: 0 }}>{title}</Title.H2>
        <Text.Medium
          color="var(--palette-blue-600)"
          style={{ marginBottom: 0, maxWidth: '100%' }}
        >
          {intro}
        </Text.Medium>
      </div>
      <div className="h d n aa"
        style={{
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))',}}
      >
        {items.map((item) => (
          <PainPointCard key={item.title} item={item} />
        ))}
      </div>
    </div>
  )
}

export default CardsSection
